<template>
  <div :class="['ocr-wraper', `${page_style}`]">
    <div class="bg" v-if="!noHalfMask"></div>
    <transition :name="isFleetPCFunnel ? '' : 'fade'">
      <div :class="{content:1,fullScreen:fullScreen, halfContent: noHalfMask}" v-show="show_ocr">
        <div class="banner" @touchstart.prevent="pullstart" @touchend="pullend">
          <div
            :class="{'pull-icon':1,down:fullScreen}"
            @touchstart.stop="fullScreen=!fullScreen"
            @touchend.stop="fn"
          ></div>
          <Banner :form-item="banner" :page_style="page_style"/>
        </div>
        <div v-for="(item,idx) in form" :key="idx">
          <Input :form-item="item" :idx="idx" @form-update="formUpdate" :page_style="page_style"/>
        </div>
      </div>
    </transition>
    <div class="bottom" :style="bottomStyle">
      <a
        :class="{'br-submit':1,'active':validForm,'vamos-active':validForm&&oasis}"
        :style="[style_submit_init,validForm&&style_submit_active]"
        @click="confirmSubmit"
      >{{submit_btn.is_check.title || $t("确认")}}</a>
      <a class="br-reUpload" @click="closeOcr">{{reset_btn.is_check.title || $t("取消")}}</a>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { post } from "../../tools/request";
import { showDialog, showAlertDialog, showLoadingToast } from "../../tools/Tip";
import { formatCPFBr, formatAccent, formatCNPJBr } from "../../tools/utils";
import Input from "./Input";
import Banner from "./Banner";

//todo notes 初始化form时，赋值，valid，解决不触发双向绑定的问题
export default {
  components: {
    Input,
    Banner,
  },
  props: {
    ocr_config: {
      default() {
        return {};
      },
    },
    show_ocr: {
      default: false,
    },
    job_uid: {
      default: "",
    },
    job_type: {
      default: "",
    },
    ocr_img: {
      default: "",
    },
    form_key: {
      default: ""
    },
    radio_type_key: {
      default:""
    },
    radio_type_value: {
      default:""
    },
    otherUp: {
      default:""
    },
    submit_btn: {
      default() {
        return {un_check: {}, is_check: {}}
      },
    },
    reset_btn: {
      default() {
        return {un_check: {}, is_check: {}}
      },
    },
    page_style: {
      default:""
    },
  },
  computed: {
    ...mapState(["_ticket", "_identity", "_area"]),
    //检查form中每一项正确性,所有form 的input、select 项必须valid为true
    validForm() {
      let needCheck = ["input", "select", "date"];
      return this.form
        .filter((x) => needCheck.includes(x.type))
        .every((x) => x.valid);
    },
    form() {
      return this.ocr_config.form || [];
    },
    banner() {
      return {
        title: this.ocr_config.title,
      };
    },
    oasis() {
      return this.params.get("business_line") === "oasis";
    },
    params() {
      return new URLSearchParams(location.search);
    },
    style_submit() {
      return this.ocr_config.button_color || this.submit_btn || { un_check: {}, is_check: {} };
    },
    style_submit_init() {
      return {
        color: this.style_submit.un_check.text_color,
        background: this.style_submit.un_check.background_color,
      };
    },
    style_submit_active() {
      return {
        color: this.style_submit.is_check.text_color,
        background: this.style_submit.is_check.background_color,
      };
    },
    noHalfMask() {
      // @20211123 漏出后面上传的照片的图层,可以对比填写 (摩西的id_no后置使用)
      return this.ocr_config.show_full_img
    },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
  },
  data() {
    return {
      fullScreen: false,
      startY: 0,
      bottomStyle: {
        bottom: 0,
      },
      initedHeight: document.body.clientHeight,
    };
  },
  mounted() {
    window.onresize = () => {
      clearTimeout(this.timeId);
      this.timeId = setTimeout((e) => {
        // let wH = window.innerHeight;
        let cH = document.body.clientHeight;
        if (this.initedHeight && cH) {
          let diff = cH - this.initedHeight;
          this.bottomStyle = {
            bottom: `${diff > 0 ? 0 : diff}px`,
          };
          if (cH < this.initedHeight) {
            this.fullScreen = true;
          }
        }
      }, 50);
    };
  },
  methods: {
    formatCPFBr,
    formatAccent,
    formatCNPJBr,
    //接收各组件发送的更新emit
    formUpdate(idx) {
      this.$set(this.form, idx, this.form[idx]);
      this.$emit("btn-update");
    },
    fn() {
      console.log("null fn");
    },
    pullstart(e) {
      this.startY = e.changedTouches[0].pageY;
    },
    pullend(e) {
      let currentY = e.changedTouches[0].pageY;
      if (currentY <= this.startY) {
        this.fullScreen = true;
      } else if (currentY > this.startY) {
        this.fullScreen = false;
      }
    },
    confirmSubmit() {
      if (!this.validForm) {
        return;
      }
      showLoadingToast(this, this.$t("加载中"));
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (this.job_type) {
        up.append("job_type", this.job_type);
      }
      if (this.job_uid) {
        up.append("job_uid", this.job_uid);
      }
      // @200922 多种类型上传组件, 外层透传radio选择类型到OCR上传 (key,value)
      if (this.radio_type_key) {
        up.append(this.radio_type_key, this.radio_type_value);
      }
      up.append(this.form_key, JSON.stringify([this.ocr_img]));

      this.form.forEach((x) => {
        if (x.key) {
          //检测是否需要清除格式
          let val = x.value;
          if (x.clear_format) {
            val = this[x.format](val, true);
          }
          up.append(x.key, val);
        }
      });
      // @20210806 小巴、轻舟等不同产品线
      let _url = process.env.ADD_AUDI_INFO;
      if (this.otherUp) {
        this.otherUp.url && this.otherUp.url.add_audi_info_url && (_url = this.otherUp.url.add_audi_info_url);
      }

      try {
        if (up.get('car_lic_type') && up.get('car_lic_type') != 1 && up.get('car_lic_type') != 2) {
          Omega.trackEvent("ibt_register_upload_new_car_lic_type_bt", "", {
            type: 'ocr',
            car_lic_type: up.get('car_lic_type'),
            radio_type_key: this.radio_type_key,
            radio_type_value: this.radio_type_value,
            form_key: this.form_key,
            req: up.toString(),
            get_detail: JSON.stringify(this.ocr_config),
          });
        }
      } catch (error) {}

      post(_url, up)
        .then((data) => {
          // 由路由控制下一步，进入证件列表页
          this.$router.replace({ name: "home" });
        })
        .catch((res) => {
          showAlertDialog(this, res.errmsg)
          try {
            Omega.trackEvent("ibt_register_submit_review_error_ck", '', {
              path_url: _url,  //接口url
              message: JSON.stringify(res),  //全部返回信息
              request: up.toString(),  //请求参数信息
              errno: res.errno,  //报错码
            });
          } catch (e) {}
        })
        .finally((x) => this.toast.hide());
      Omega.trackEvent("gd_oasisOCRresult_confirm_ck", "", {
        type: this.form_key,
      });
    },
    closeOcr() {
      this.$emit("closeOcr");
      Omega.trackEvent("gd_oasisOCRresult_cancel_ck", "", {
        type: this.form_key,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transform: translateY(0%);
}
.fade-enter,
.fade-leave-to,
.fade-leave-active {
  transform: translateY(100%);
}
.ocr-wraper {
  position: fixed;
  z-index: 6;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .bg {
    top: 0;
    left: 0;
    position: fixed;
    height: 100%;
    width: 100%;
    background: rgba(15, 25, 40, 0.6);
    z-index: 10;
  }
  .content {
    position: absolute;
    bottom: 0;
    z-index: 11;
    width: 100%;
    height: 70%;
    box-sizing: border-box;
    padding-bottom: 3.12rem;
    overflow: auto;
    background: #f5f5f7;
    transition: all 0.3s ease;
    &.halfContent {
      height: 55%;
    }
    &.fullScreen {
      height: 100%;
    }
    .banner {
      position: relative;
      min-height: 1.1rem;
      padding-top: 0.08rem;
      margin-bottom: 0.17rem;
      background: #fff;
      border-radius: 0.15rem 0.15rem 0 0;
      .pull-icon {
        position: absolute;
        top: 0.16rem;
        left: 50%;
        width: 0.6rem;
        height: 0.16rem;
        background: url("../../images/pull-up@2x.png") no-repeat;
        background-size: 100%;
        transform: translateX(-50%);
      }
      .down {
        background: url("../../images/pull-down@2x.png") no-repeat;
        background-size: 100%;
      }
    }
  }
  &.h5_funnel_fleet,
  &.h5_funnel_fleet_pc {
    .bg {
      background: rgba(15,25,40,0.60);
    }
    .content {
      border-top-left-radius: 0.3rem;
      border-top-right-radius: 0.3rem;
      background: #FFFFFF;
      .banner {
        margin-bottom: 0;
        min-height: auto;
        padding-top: 0.04rem;
        padding-bottom: 0.14rem
      }
    }
    .bottom {
      a.br-submit,
      a.br-reUpload {
        width: 100%;
        box-sizing: border-box;
        border-radius: 0.2rem;
        font-weight: 700;
        font-size: 0.4rem;
      }
      a.active {
        color: #FFFFFF;
        background-image: linear-gradient(145deg, #FF7D41 0%, rgba(255,116,15,0.75) 99%);
      }
    }
  }
  &.h5_funnel_fleet_pc {
    position: absolute;
    top: 46px;

    .bg {
      display: none;
    }

    .content {
      position: relative;
      height: 100%;
      .banner {
        padding: 0;
        .pull-icon {
          display: none;
        }

        ::v-deep .banner-wrapper {
          padding: 0 40px 24px;
          .title {
            padding-top: 40px;
            font-size: 20px !important;
            color: #000000;
            font-weight: 700;
          }
        }
      }
      ::v-deep .input-wraper {
        padding: 12px 40px 0 40px;
      }
    }
    .bottom {
      display: flex;
      justify-content: flex-start;
      flex-direction: row-reverse;
      position: absolute;
      height: 80px;
      padding: 24px;
      box-shadow: none;
      text-align: right;
      a.br-submit,
      a.br-reUpload {
        width: auto;
        display: inline-block;
        padding: 6px 16px;
        box-sizing: border-box;
        height: 32px;
        line-height: 20px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 4px;
        vertical-align: middle;
        &:first-child {
          margin-bottom: 0;
          margin-left: 12px;
        }
      }
    }
  }
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  z-index: 12;
  padding: 0.36rem 0.32rem;
  background: #fff;
  // transition: bottom 0.3s linear;
  > a {
    display: block;
    &:first-child {
      margin-bottom: 0.2rem;
    }
  }
  a.br-submit {
    color: #fff;
    background-color: #afb0b3;
  }
  a.active {
    color: #323233;
    background-color: #ffe600;
  }
  a.vamos-active {
    background: linear-gradient(135deg, #fff362 0%, #fd9728 100%);
  }
}
</style>
